import {Component, inject} from '@angular/core';
import {ToastService} from '../../../services/toast.service';
import {NgComponentOutlet} from '@angular/common';

@Component({
  selector: 'app-toasts',
  imports: [
    NgComponentOutlet
  ],
  templateUrl: './toasts.component.html',
  styleUrl: './toasts.component.scss'
})
export class ToastsComponent {
  protected readonly toastService = inject(ToastService)
}
